/**
 * Processing Locks
 *
 * Manages locks to prevent duplicate processing of AI edits for the same clip.
 */
const processingLocks = new Set<string>();

export function acquireLock(clipId: string): boolean {
  if (processingLocks.has(clipId)) {
    return false;
  }
  processingLocks.add(clipId);
  return true;
}

export function releaseLock(clipId: string): void {
  processingLocks.delete(clipId);
}
